//words to be omitted from initials
export const WORDS_OMITTED_FROM_INITIALS = ["mr", "mrs", "the", "miss", "dr", "of", "sir"];
export const MAX_INITIALS_LENGTH = 4;

export const MAX_SHORT_LABEL_LENGTH = 30;
